// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// MUI components
import Box from '@mui/material/Box';

import SelectedLinesProvider from '@providers/MansionNavigation/SelectedLinesProvider';
import LinesList from './LinesList';
import LinesSearch from './LinesSearch';

// Section for type definition -----------------------------------------------------------------------------------------

export default function LinesSelector(props: any) {
  const { prefecturesData } = props;
  const { modePrefSelect } = props;
  const { selectedPrefecture } = props;
  const { selectedLine } = props;

  // Section for render component --------------------------------------------------------------------------------------
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <SelectedLinesProvider>
      <Box className="md:pb-10">
        <LinesList
          prefecturesData={prefecturesData}
          selectedPrefecture={selectedPrefecture}
          selectedLine={selectedLine}
          modePrefSelect="prefectures"
        />
        <LinesSearch modePrefSelect={modePrefSelect} selectedPrefecture={selectedPrefecture} />
      </Box>
    </SelectedLinesProvider>
  );
}
